{
  "DocumentViewer_AcceptButton": "Accept",
  "DocumentViewer_CloseButton": "Close",
  "NAME": "DocumentViewer"
}